import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { SubGroupQueries } from '@/services/groupsManagement/subGroups.queries';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useManageSubGroup = (groupId?: string) => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('manageSubGroup', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: SubGroupQueries.all() });
      await revalidate(['searchGroups', 'all']);

      if (groupId) {
        await queryClient.invalidateQueries({ queryKey: SubGroupQueries.all() });
        await revalidate(['searchGroups', 'all']);
      }
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsync };
};

export default useManageSubGroup;
